import normalizeText from "normalize-text";

export const normalizeObject = (object) => {
  return normalizeText(JSON.stringify(object));
};

export const objectIncludes = (object, keyword) => {
  return normalizeObject(object || {}).includes(keyword);
};

export const objectIncludesLower = (object, keyword) => {
  return normalizeObject(object || {})
    .toLowerCase()
    .includes(keyword);
};
